import React from 'react'
import { Link } from 'gatsby'

const ArticleLanguageLinks = ({ article }) => {

    if (article.languageAlternativesHreflang) {

        return (
            <>
                {
                    article.languageAlternativesHreflang.map((item, i) => (
                        <p key={i}>
                            <Link to={item.alternateUrl}>
                                Read this article in {" "}
                                {new Intl.DisplayNames(['en'], {
                                    type: 'language'
                                }).of(item.language)}
                            </Link>
                        </p>
                    ))
                }
            </>
        )
    }

    return null;

}

export default ArticleLanguageLinks
